import { Edit, SimpleForm, TextInput, usePermissions } from "react-admin";
import { hasPermission } from "@/utils/permission-utils";
import NoArrowKeyNumberInput from "@/components/NoArrowKeyNumberInput";

export const EventSequenceEdit = () => {
  const { permissions } = usePermissions();
  const canEdit = hasPermission(permissions, "event.edit");

  if (!canEdit) {
    return <div style={{ padding: 20 }}>You do not have permission to edit event sequences.</div>;
  }

  return (
    <Edit mutationMode="pessimistic" resource="eventSequences">
      <SimpleForm warnWhenUnsavedChanges sx={{ maxWidth: 700 }}>
        <TextInput source="type" label="Type" disabled fullWidth />
        <TextInput source="venueCode" label="Venue code" disabled fullWidth />
        <TextInput source="prefix" label="Prefix" fullWidth />
        <NoArrowKeyNumberInput source="currentValue" label="Current value" fullWidth />
        <TextInput source="eventId" label="Event ID" disabled fullWidth />
      </SimpleForm>
    </Edit>
  );
};
